var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedicalcheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.16613 13.7748C4.71195 13.775 4.27638 13.5944 3.9555 13.273L0.295374 9.61425C-0.098458 9.22029 -0.098458 8.58169 0.295374 8.18773C0.689332 7.7939 1.32794 7.7939 1.72189 8.18773L5.16613 11.632L14.2781 2.51998C14.6721 2.12615 15.3107 2.12615 15.7046 2.51998C16.0985 2.91394 16.0985 3.55255 15.7046 3.9465L6.37675 13.273C6.05587 13.5944 5.6203 13.775 5.16613 13.7748Z",
    fill: "#119975"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalcheck);
export default __webpack_public_path__ + "static/media/Medicalcheck.8ddc2c0f47424f1020efa32beea0739e.svg";
export { ForwardRef as ReactComponent };